const zoomInHandler = (photo, setIsZoomedIn, setCurrentPhoto) => {
  setCurrentPhoto(photo);
  setIsZoomedIn(true);
};

const zoomOutHandler = (setZoomedIn) => {
  setZoomedIn(false);
};

const importPhotos = (r) => {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};

const getImagesNames = (images) => {
  const imagesNames = [];
  for (const key in images) {
    if (Object.hasOwnProperty.call(images, key)) {
      imagesNames.push(images[key].default);
    }
  }
  return imagesNames;
};

//   const images = importAll(
//     require.context("../assets/info", false, /.*_th\.(JPG|png|jpe?g|svg)$/)
//   );

//   const imagesNames = [];
//   for (const key in images) {
//     if (Object.hasOwnProperty.call(images, key)) {
//       imagesNames.push(images[key].default);
//     }
//   }

//   return imagesNames;
// };

const galleryHelpers = {
  zoomInHandler,
  zoomOutHandler,
  importPhotos,
  getImagesNames,
};
export default galleryHelpers;
